import { render, staticRenderFns } from "./BuilderHeaderSaveButton.vue?vue&type=template&id=ab3b9876&scoped=true&"
import script from "./BuilderHeaderSaveButton.vue?vue&type=script&lang=js&"
export * from "./BuilderHeaderSaveButton.vue?vue&type=script&lang=js&"
import style0 from "./BuilderHeaderSaveButton.vue?vue&type=style&index=0&id=ab3b9876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3b9876",
  null
  
)

export default component.exports